"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Container = _styledComponents.default.div`
  display: flex;
  padding: 0px 16px;

  @media (min-width: 768px) {
    padding: 0px 16px;
  }
`;
const ImageContainer = _styledComponents.default.div`
  @media (min-width: 768px) {
    margin: 0px 8px;
    height: 80vh;
    height: calc(100vh - 170px);
    width: ${props => `calc(${props.aspectRatio * 100}vh - ${props.aspectRatio * 170}px)`};
  }
`;
const Image = _styledComponents.default.img`
  max-width: 100%;
  max-height: 100%;
`;
const Images = ({
  items
}) => {
  return _react.default.createElement(Container, null, items?.map(item => _react.default.createElement(ImageContainer, {
    key: item.src,
    aspectRatio: item.aspectRatio
  }, _react.default.createElement(Image, {
    srcSet: item.srcSet,
    aspectRatio: item.aspectRatio,
    src: item.src
  }))));
};
var _default = Images;
exports.default = _default;
//# sourceMappingURL=Images.js.map